import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { SamplingWorkspaceStore } from '../../../sampling-workspace/state/sampling-workspace-store';
import { addFeedbackIcon } from '../../../shared/icons/feedback/add-feedback-icon';
import { FieldFeedbackService } from '../../services/field-feedback.service';
import { FieldFeedback } from '../../types/field-feedback';
import { FeedbackItemComponent } from '../feedback-item/feedback-item.component';
import { FeedbackPanelComponent } from '../feedback-panel/feedback-panel.component';

@Component({
  selector: 'h3-field-feedback-list',
  imports: [
    CommonModule,
    FeedbackItemComponent,
    FeedbackPanelComponent,
    MatIcon,
    MatIconButton,
  ],
  templateUrl: './field-feedback-list.component.html',
  styleUrl: './field-feedback-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldFeedbackListComponent {
  @Input({ required: true }) feedbackItems!: FieldFeedback[];
  @Input({ required: true }) outputId!: number;

  private readonly store = inject(TaskWorkspaceStore);
  private readonly fieldFeedbackService = inject(FieldFeedbackService);
  private readonly sampleStore = inject(SamplingWorkspaceStore);

  isUpdateFeedbackAllowed$ = combineLatest([
    this.store('workspace').$,
    this.sampleStore.hasSampleFinalized$(),
  ]).pipe(
    map(
      ([workspace, hasSampleFinalized]) =>
        workspace === 'sampling' && !hasSampleFinalized,
    ),
  );
  addFeedbackIcon = addFeedbackIcon;
  selectedIndex$ = this.store('fieldFeedbackPopover')('selectedIndex').$;

  selectFeedback(index: number) {
    this.store('fieldFeedbackPopover')('selectedIndex').set(index);
  }

  editFeedback(index: number) {
    this.store('fieldFeedbackPopover').assign({
      selectedIndex: index,
      target: 'upsert',
    });
  }

  deleteFeedback(index: number) {
    this.fieldFeedbackService.delete(index);
  }

  close() {
    this.fieldFeedbackService.close();
  }

  addFeedback() {
    this.store('fieldFeedbackPopover')('selectedIndex').delete();
    this.fieldFeedbackService.open(this.outputId, 'upsert');
  }
}
